import React from 'react';

import { Button, EmptyState, File, FileDropzone } from 'components/index';

import style from './AnalysisInvoices.module.scss';

const AnalysisInvoices = ({ files = [], setFiles, onSubmit }) => {
  const handleClearFile = (file) => {
    setFiles(files.filter((f) => f !== file));
  };

  const handleFileChange = (file) => {
    if (file) setFiles([...files, file]);
  };

  return (
    <div className={style.container}>
      <FileDropzone
        accept={'.pdf, .jpeg, .jpg, .png, .webp'}
        onChange={handleFileChange}
      />
      <div className={style.list}>
        {files.map((file, i) => (
          <File
            key={`invoice-file-${i}`}
            value={file}
            handleClearFile={() => handleClearFile(file)}
          />
        ))}
        {files.length === 0 && (
          <EmptyState
            type='noInvoicesAttached'
            className={style.empty}
          />
        )}
      </div>
      <Button
        label={'Dołącz do formularza'}
        onClick={onSubmit}
      />
    </div>
  );
};

export default AnalysisInvoices;
